import videojs from 'video.js';

const Component = videojs.getComponent('Component');

// Базовый класс элемента авторизации
export default class AuthProviderItem extends Component {
  /**
   * @param {HTMLElement} containerEl - элемент, содержащий в себе элемент со списком соц. сетей для
   * авторизации
   * @param {HTMLElement} menuEl - элемент, содержащий в себе список соц. сетей для авторизации
   */
  constructor(providerName, menu) {
    const options = { id: `vjs-chat-auth-provider-${providerName}` };
    super(menu.player, options);
    this.providerName = providerName;
    this.menu = menu;
  }

  createEl() {
    const el = videojs.createEl('li', {
      className: 'vjs-chat-popup__social-network-item'
    });

    el.innerHTML += this.template;

    return el;
  }

  get template() {
    return '';
  }

  get containerEl() {
    return this.menu.containerEl;
  }

  get menuEl() {
    return this.menu.menuEl;
  }

  // Элемент, при нажатии на который инициируется процесс авторизации
  get authEl() {
    return this.el();
  }

  get eventData() {
    return {
      provider: this.providerName
    };
  }

  _showElement(el) {
    el.classList.remove('vjs-hidden');
  }

  _hideElement(el) {
    el.classList.add('vjs-hidden');
  }

  // Установка событий при нажатии на элемент из списка
  _setDomListeners() {
    this.authEl.addEventListener('click', () => {
      this.trigger({ type: 'authProviderChoosed', data: this.eventData });
    });
  }

  // Отрисовка элемента меню
  render() {
    this.menuEl.append(this.el());
    this._setDomListeners();
  }
}
